// Import icon components from Iconify
import { Icon } from '@iconify/react'
import Box from '@mui/material/Box'
// Import core MUI components for layout and styling
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
// Import custom components for typography, styling and input
import { Button } from '@/components/atoms'
import { Input } from '@/components/atoms/input'
import { MvTypography } from '@/components/atoms/mv-typography'
import { Field } from '@/components/molecules/field'
// Import custom types for handling notification data
import { NotificationProps } from '../types/Notification.type'

// Import utility functions for grouping notif item by date
import { groupNotifByDate } from '../utils'

// Import custom components for notification item
import { NotificationItem } from './NotificationItem'

export function Notification({
  data = [],
  size = 'small',
  handleReadAll,
  handleSeeAll,
  handleReadSingle,
  onClose,
  setSearch = () => {},
  selectedFilter,
  setSelectedFilter = () => {}
}: NotificationProps) {
  const theme = useTheme()

  const groupedNotif = groupNotifByDate(data)

  return (
    <Stack
      sx={{
        borderRadius: 2,
        backgroundColor: theme.colorToken.background.paper,
        width: size === 'small' ? 345 : 'auto'
      }}
    >
      <Stack direction='row' justifyContent='space-between' sx={{ p: 2 }}>
        <MvTypography size='TITLE_MD' typeSize='PX'>
          Notification
        </MvTypography>
        {size === 'small' ? (
          <IconButton size='small' onClick={onClose} sx={{ fontSize: '20px', padding: '6px' }}>
            <Icon icon='tabler:x' />
          </IconButton>
        ) : (
          <Button content='textOnly' text='Mark all as read' onClick={handleReadAll} />
        )}
      </Stack>
      {size === 'large' && (
        <Stack direction='row' sx={{ py: 4, gap: 2 }}>
          <Chip
            label='All Notification'
            onClick={() => setSelectedFilter('all')}
            variant={selectedFilter === 'all' ? 'filled' : 'outlined'}
            color={selectedFilter === 'all' ? 'primary' : 'secondary'}
          />
          <Chip
            label='Unread'
            onClick={() => setSelectedFilter('unread')}
            variant={selectedFilter === 'unread' ? 'filled' : 'outlined'}
            color={selectedFilter === 'unread' ? 'primary' : 'secondary'}
          />
        </Stack>
      )}
      {size === 'small' && <Divider />}
      <Stack
        direction='column'
        sx={{
          py: 2,
          border: size === 'large' ? `1px solid ${theme.colorToken.border.neutral.normal}` : 'none',
          borderRadius: '8px'
        }}
      >
        {size === 'large' ? (
          <Box sx={{ px: 2, margin: '6px 0 16px' }}>
            <Field>
              <Input
                type='text'
                variant='outlined'
                width={'230px'}
                onChange={e => setSearch(e.target.value)}
                placeholder='Search by notification'
                iconStartAdornment='tabler:search'
              />
            </Field>
          </Box>
        ) : null}
        {groupedNotif.map((item, idx) => (
          <Box key={idx}>
            <MvTypography size='LABEL_LG_BOLDEST' typeSize='PX' sx={{ p: 2 }}>
              {item.date}
            </MvTypography>
            {item.data.map((notif, idx) => (
              <NotificationItem key={idx} notif={notif} size={size} handleReadSingle={handleReadSingle} />
            ))}
          </Box>
        ))}
      </Stack>
      {size === 'small' && (
        <Stack direction='row' justifyContent='space-between' sx={{ p: 2 }}>
          <Button content='textOnly' text='Mark all as read' onClick={handleReadAll} />
          <Button content='textOnly' text='See all notification' variant='outlined' onClick={handleSeeAll} />
        </Stack>
      )}
    </Stack>
  )
}
